import type { ReactNode } from "react";
import { useState, useCallback } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { hexToRGB } from "../../utils/style";

/**
 * Accordion Component
 */
type AccordionProps = {
  title: string;
  children: ReactNode;
};

const Header = styled.div`
  padding: 18px;
  display: flex;
  justify-content: space-between;
  background: ${(props) =>
    hexToRGB(props.theme.colors.secondaryBackground, 0.1)};
  cursor: pointer;
`;

const Title = styled.h2`
  font-size: 18px;
  font-weight: bold;
`;

const Arrow = styled.div`
  font-size: 18px;
`;

const Items = styled.div<{ $isOpen: boolean }>`
  ${({ $isOpen }) => !$isOpen && `display: none;`}
`;

export function Accordion({ title, children }: AccordionProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggleVisibility = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen, setIsOpen]);

  return (
    <>
      <Header onClick={toggleVisibility}>
        <Title>{title}</Title>
        <Arrow>
          {isOpen ? (
            <FontAwesomeIcon icon={"chevron-up"} />
          ) : (
            <FontAwesomeIcon icon={"chevron-down"} />
          )}
        </Arrow>
      </Header>
      <Items $isOpen={isOpen}>{children}</Items>
    </>
  );
}
